const productTitles = [
  { title: "제품명", enTitle: "Specification" },
  { title: "상품코드", enTitle: "Code" },
  { title: "구분", enTitle: "Category" },
  { title: "종류", enTitle: "Subcategory" },
  { title: "사이즈", enTitle: "Size (W*L*T)" },
  { title: "제조사", enTitle: "Manufacturer" },
  { title: "원산지", enTitle: "Country of Origin" },
  { title: "광택도", enTitle: "Glossiness" },
];

export default productTitles;
